import { render, staticRenderFns } from "./DatiAzienda.vue?vue&type=template&id=29b66592&scoped=true"
import script from "./DatiAzienda.vue?vue&type=script&lang=ts"
export * from "./DatiAzienda.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b66592",
  null
  
)

export default component.exports